import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/ContactUs.css';

const ContactUs = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handleSubmit = (e) => { e.preventDefault(); setSubmitted(true); };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-inner">
        <div className="contact-info">
          <span className="home-badge">{t('contact_title')}</span>
          <h2>{t('get_in_touch')}</h2>
          <p>{t('get_in_touch_desc')}</p>
          <div className="contact-details">
            <div className="cd-item"><span>📧</span><div><strong>{t('contact_info_email')}</strong><span>support@istanbulguide.com</span></div></div>
            <div className="cd-item"><span>🕐</span><div><strong>{t('contact_info_hours')}</strong><span>{t('business_hours_weekday')}</span><span>{t('business_hours_saturday')}</span></div></div>
          </div>
        </div>
        <div className="contact-form-box">
          <h3>{t('send_us_message')}</h3>
          {submitted ? (
            <div className="contact-success">✅ {t('contact_form_submitted')}</div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="cf-field">
                <label>{t('contact_form_name')}</label>
                <input type="text" name="name" placeholder={t('your_full_name')} value={form.name} onChange={handleChange} required />
              </div>
              <div className="cf-field">
                <label>{t('contact_form_email')}</label>
                <input type="email" name="email" placeholder="you@example.com" value={form.email} onChange={handleChange} required />
              </div>
              <div className="cf-field">
                <label>{t('contact_form_subject')}</label>
                <input type="text" name="subject" placeholder={t('what_is_this_about')} value={form.subject} onChange={handleChange} required />
              </div>
              <div className="cf-field">
                <label>{t('contact_form_message')}</label>
                <textarea name="message" rows="4" placeholder={t('tell_us_more')} value={form.message} onChange={handleChange} required />
              </div>
              <button type="submit" className="cf-submit">{t('contact_form_submit')}</button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
